import { c as _c } from "react/compiler-runtime";
import Tippy from '@tippy.js/react';
const Tooltip = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Tippy theme="tooltip" boundary="viewport" animation="fade" duration={300} arrow={true} delay={250} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default Tooltip;